import React from "react";
import { Calendar, Eye, Feather, Users, Youtube } from "react-feather";
import { Link } from "react-router-dom";
import { InfluencerNote } from "../../../Shared/Notes/NoteContainer";
import { addDefaultSrc, dateString } from "../../../utilities";
// import { Loader } from '../../shared/loader';

const ChatNav = ({ user, influencer, note, loading, recipientImage }) =>
  !loading && user && user._id ? (
    <div className="chat-nav">
      <img
        src={recipientImage}
        onError={(event) =>
          addDefaultSrc(
            event,
            require("@src/assets/images/vyrill/default-creators.png").default
          )
        }
        alt=""
      />
      <div className="receiver-name">
        {user && `${user.first_name} ${user.last_name}`}
      </div>
      {influencer && (
        <div>
          <div className="receiver-details">
            <div className="receiver-detail">
              <Calendar size={15} />{" "}
              {dateString(influencer.latest_platform_video_published_at)}
            </div>
            <div className="receiver-detail">
              <Feather size={15} /> {influencer.author_type}
            </div>
            <div className="receiver-detail">
              <Users size={15} /> {influencer.total_subscribers}
            </div>
            <div className="receiver-detail">
              <Youtube size={15} /> {influencer.statistics_videocount}
            </div>
            <div className="receiver-detail">
              <Eye size={15} /> {influencer.statistics_viewcount}
            </div>
          </div>
          <div className="card-footer">
            <Link to={`/influencers/${influencer._id}`} className="link">
              View Creator
            </Link>
            {/* <InfluencerNote note={note} id={influencer._id} /> */}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="chat-nav">
      {/* <Loader noText /> */}
      Loader
    </div>
  );

export default ChatNav;
